<template>
  <transition name="fade">
    <div
      class="modal"
      v-if="show"
      style="z-index:1000"
    >
      <div
        class="container"
        element-loading-text="正在获取推送列表，请稍后。。。"
        v-loading='loading'
      >
        <div class="container_top el-message-box__header msp_icon_close">
          <span class="container_top_title">推送服务列表</span>
          <span
            class="iconfont el-icon-close"
            v-on:click="closeModal()"
          ></span>
        </div>
        <div
          class="push_service"
          v-if='pushServiceList.length > 0 || newMediapushServiceList.length > 0'
        >
          <div style="margin-bottom:20px;margin-top:0px;height:34px;display:flex;align-items:center;">
            <span style="width:4px;height:16px;display:inline-block;background:#688eff;margin-right:6px;"></span>
            <span>自有媒体端</span>
          </div>
          <div
            class="each_push_service"
            v-for='item in pushServiceList'
            @click.stop='pushEveryEndPoInt(item)'
            v-if="(pushType === 'typeIsPush') || 
            (
              pushType === 'typeIsCanclePush' && (
                item.id==='id_gsh_app' || 
                item.id==='id_sandu_cms_app' || 
                item.id==='id_bhws_app' || 
                item.id==='id_zhongwang_app_v2' || 
                item.id==='id_gzu_cms' || 
                item.id==='id_mrp_cms' || 
                item.id==='id_zw_app' || 
                item.id === 'id_gzvcfe_cms' ||
                item.id === 'id_kaili_xueyuan'
              )
            )"
          >
            <div class="each_push_serviceimg">
              <img
                :src="item.icon"
                alt=""
              >
            </div>
            <div class="each_push_service_text">
              <span>{{item.edpnt_name}}</span>
            </div>
          </div>

          <div style="margin-bottom:20px;margin-top:20px;height:34px;display:flex;align-items:center;">
            <span style="width:4px;height:16px;display:inline-block;background:#688eff;margin-right:6px;"></span>
            <span>新媒体端</span>
          </div>
          <div
            class="each_push_service"
            v-for='item in newMediapushServiceList'
            @click.stop='pushEveryEndPoInt(item)'
          >
            <div class="each_push_serviceimg">
              <img
                :src="item.icon"
                alt=""
              >
            </div>
            <div class="each_push_service_text">
              <span>{{item.edpnt_name}}</span>
            </div>
          </div>

        </div>

        <div
          class="no_data"
          v-if='pushServiceList.length === 0 && newMediapushServiceList.length === 0'
        >
          <img
            src="../../../static/img/nopushdata.png"
            alt=""
          >
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
export default {

  components: {

  },

  created () {


  },

  mounted () {
    this.$root.eventHub.$on('setPushService', (obj, type) => {
      this.show = true
      this.pushObj = obj
      this.pushType = type
      this.getPushServiceList()
      if (type === 'typeIsPush') {
        this.getNewMediaPushService()
      }

    })

  },

  destroyed () {
    this.$root.eventHub.$off('setPushService')
  },

  data () {
    return {
      show: false,
      pushObj: '',
      pushServiceList: [],
      pushType: '',
      loading: false,
      newMediapushServiceList: []
    }
  },

  updated () {

  },

  computed: {
    userId () {
      return this.$store.state.userinfo.usercode
    },
    token () {
      return this.$store.state.userinfo.token
    },
    seed () {
      return this.$store.state.userinfo.seed
    },
    orgId () {
      return this.$store.state.userinfo.company_id
    }

  },

  methods: {
    closeModal () {
      this.show = false
    },
    getPushServiceList () {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
        }
      }
      this.loading = true
      api._post(_PUSHURL_ + 'system/push_service/get_server', option).then((res) => {
        if (res.code == 200) {
          this.pushServiceList = res.data
        }
        this.loading = false
      }).catch((error) => {
        this.pushServiceList = []
        console.error(error)
        this.loading = false
      })
    },
    getNewMediaPushService () {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
        }
      }
      this.loading = true
      api._post(_PUSHURL_ + 'system/push_service/get_server_d', option).then((res) => {
        if (res.code == 200) {
          this.newMediapushServiceList = res.data
        }
        this.loading = false
      }).catch((error) => {
        this.newMediapushServiceList = []
        console.error(error)
        this.loading = false
      })
    },
    pushEveryEndPoInt (item) {
      if (this.pushType === 'typeIsPush') {
        this.$root.eventHub.$emit('pushEachServiceModel', this.pushObj, item.id)
      } else if (this.pushType === 'typeIsCanclePush') {
        this.$root.eventHub.$emit('setAuditModel', item, 'canclePushArticle', this.pushObj)
      }
    }

  },

  watch: {
    show () {
      if (this.show == false) {
        this.pushObj = ''
        this.pushServiceList = []
        this.newMediapushServiceList = []
      }
    }

  }
}

</script>

<style scoped>
@import "../../../static/css/modal.css";

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}

.expand-transition {
  transition: all 1s ease;
}

.expand-enter,
.expand-leave {
  opacity: 0;
}

.expand-enter .container,
.expand-leave .container {
  /*margin-top: -800px;*/
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.container {
  transition: all 1s ease;
  width: 930px;
  height: 750px;
  position: fixed;
  left: 25%;
  top: 10%;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px #999;
  border-radius: 5px;
  z-index: 101;
  display: flex;
  flex-direction: column;
}

.container_top {
  width: 100%;
}

.container_top .iconfont {
  float: right;
  font-size: 20px;
  cursor: pointer;
  line-height: 48px;
  margin-right: 20px;
}

.container_top .container_top_title {
  display: inline-block;
  color: #303133;
  font-size: 16px;
  font-family: "微软雅黑";
  text-align: center;
  line-height: 48px;
}
.push_service {
  padding-left: 30px;
  padding-top: 20px;
  width: 100%;
  height: calc(100% - 60px);
  overflow: auto;
  position: relative;
}
.each_push_service {
  width: 100px;
  margin-right: 28px;
  margin-bottom: 30px;
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  position: relative;
}
.each_push_serviceimg {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.each_push_serviceimg img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.each_push_service_text {
  width: 100%;
  display: flex;
  justify-content: center;
}
.each_push_service_text span {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.no_data {
  position: absolute;
  left: 280px;
  top: 195px;
}
</style>